import "core-js/modules/es.function.name.js";
import useRightPath from '~/composables/useRightPath';
import usePreventHandlingEmptyLink from '~/composables/usePreventHandlingEmptyLink';
import AzImg from '~/components/Atoms/AzImg.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
export default defineComponent({
  name: 'EquipmentList',
  components: {
    AzImg: AzImg,
    NuxtLinkCustom: NuxtLinkCustom
  },
  props: {
    activeTab: {
      type: String
    },
    equipment: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(_props) {
    var _useRightPath = useRightPath(),
      getProductPath = _useRightPath.getProductPath;
    var getEquipmentName = function getEquipmentName(equipment) {
      var _equipment$nonPurchas, _equipment$nonPurchas2;
      if (equipment.name) {
        return equipment.name;
      }
      var title = equipment === null || equipment === void 0 ? void 0 : (_equipment$nonPurchas = equipment.nonPurchasableEquipment) === null || _equipment$nonPurchas === void 0 ? void 0 : (_equipment$nonPurchas2 = _equipment$nonPurchas.fields) === null || _equipment$nonPurchas2 === void 0 ? void 0 : _equipment$nonPurchas2.title;
      return title || '';
    };
    var getEquipmentImage = function getEquipmentImage(equipment) {
      var _equipment$nonPurchas3, _equipment$nonPurchas4, _equipment$nonPurchas5, _equipment$nonPurchas6, _equipment$nonPurchas7;
      if (equipment.image) {
        return equipment.image;
      }
      var url = (_equipment$nonPurchas3 = equipment.nonPurchasableEquipment) === null || _equipment$nonPurchas3 === void 0 ? void 0 : (_equipment$nonPurchas4 = _equipment$nonPurchas3.fields) === null || _equipment$nonPurchas4 === void 0 ? void 0 : (_equipment$nonPurchas5 = _equipment$nonPurchas4.image) === null || _equipment$nonPurchas5 === void 0 ? void 0 : (_equipment$nonPurchas6 = _equipment$nonPurchas5.fields) === null || _equipment$nonPurchas6 === void 0 ? void 0 : (_equipment$nonPurchas7 = _equipment$nonPurchas6.file) === null || _equipment$nonPurchas7 === void 0 ? void 0 : _equipment$nonPurchas7.url;
      return url;
    };
    var getLink = function getLink(slug) {
      return slug ? getProductPath({
        slug: slug
      }) : '';
    };
    return {
      getEquipmentName: getEquipmentName,
      getEquipmentImage: getEquipmentImage,
      getLink: getLink,
      usePreventHandlingEmptyLink: usePreventHandlingEmptyLink
    };
  }
});